import { Notificacao } from './../models/notificacao';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { LocalStorageService } from './local-storage.service';
import { AutenticacaoService } from './autenticacao.service';
import { environment } from './../../environments/environment';
import { Observable } from "rxjs/Rx";

@Injectable()
export class NotificacaoService {

  private API_URL: string = environment.apiUrl;
  
  constructor
  (
    private http: Http,
    private autenticacaoService: AutenticacaoService,
    private localStorage: LocalStorageService
  )
  { }

  public obterNotificacoes(): Observable<Array<Notificacao>>{
    return this.http.get(`${this.API_URL}notificacoes`)
      .map(response => response.json(), error => error.json());
  }
  
  public obterNotificacao(id:number): Observable<Notificacao> {
    return this.http.get(`${this.API_URL}notificacoes/${id}`)
      .map(response => response.json(),error => error.json());
  }

  public adicionarNotificacao(noticacao: Notificacao): Observable<any> {
    return this.http.post(`${this.API_URL}notificacoes`, noticacao)
      .map(response => response.json(), error => error.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/app-services/notificacao.service.ts